/**
 * ITALIENISCH VISUELL™ (DACH) — every text of the landing, in German (du).
 * Section order copied from the Brazilian page we model ("Italiano Visual Premium", clubedamateria.com.br/italianovisual, 02/11).
 * Same arguments, our texts. Not copied: the "only on 31/10, 1 and 2/11" bar and the countdown (fake urgency),
 * "+5.000 Lehrer und Schüler", the testimonials and prints (we have none), "Wurzeln/Staatsbürgerschaft" (in DACH the hook is the holiday).
 * Numbers, price, bonus names and guarantee MUST match the Impultienda checkout and the PDFs.
 * Marks inside titles: ==red highlight==
 */
export { META_PIXEL_ID, PIXEL_DRY_RUN } from './pixel';

export const LANG = 'de';
export const PAGE_TITLE = 'Italienisch Visuell™ – 300 Mindmaps: Italienisch für deinen Urlaub';
export const META_DESCRIPTION =
  'Italienisch lernen mit 300 illustrierten Mindmaps in 20 Kapiteln (A1–A2): vom ersten «Ciao» bis zum Gespräch im Urlaub. PDF zum Lesen am Handy oder zum Ausdrucken.';

/** The ONLY link to the checkout (offer card button). */
export const CHECKOUT_URL = 'https://italienisch-visuell.impultienda.ar/checkout';

export const pricing = {
  value: 19.9,
  currency: 'EUR',
  price: '19,90 €',
  /** Value stack: main 49 € + 5 bonuses of 13 € (same values as the checkout) */
  mainValue: '49 €',
  bonusValue: '13 €',
  totalLabel: 'Gesamtwert',
  totalValue: '114 €',
  todayLabel: 'Dein Preis',
  savings: 'Du sparst 94,10 €',
  note: 'Einmalzahlung, kein Abo · in der Schweiz CHF 19.90',
};

export const trust = ['10 Tage Geld-zurück-Garantie', 'Sichere Zahlung', 'PDF sofort per E-Mail'];

export const topBar = '🇮🇹 Sofort-Download · PDF zum Lesen am Handy oder zum Ausdrucken';

export const hero = {
  kicker: 'Für alle, die im Urlaub endlich Italienisch sprechen wollen',
  title: '300 Mindmaps, mit denen du Italienisch ==für deinen Urlaub== lernst',
  sub: 'Vom ersten «Ciao» bis zum Gespräch im Restaurant – ohne Vokabellisten, ohne Kurs, in deinem Tempo.',
  cta: 'Ja, ich will Italienisch lernen',
  mockupAlt: 'Italienisch Visuell: Box mit dem Buch (300 Mindmaps) und den 5 Bonus-Heften',
};

export const material = {
  kicker: 'Ohne Überraschungen',
  title: 'So sieht das Material aus, ==das du bekommst==',
  sub: 'Jedes Thema auf einer Seite: das Wichtigste, die Regel, Beispiele mit Übersetzung, der typische Fehler und ein Mini-Dialog für den Urlaub.',
  swipe: '← Wisch und sieh dir das Material an →',
  cta: 'Ich will das Material',
};

export const zuhause = {
  kicker: 'In der Praxis',
  title: 'So sieht es bei dir ==zu Hause== aus',
  sub: 'Am Handy lesen oder ausdrucken, abhaken und mitnehmen.',
  alts: [
    'Mindmap ausgedruckt auf dem Küchentisch, mit Kaffee und Lesebrille',
    'Mindmap mit Textmarker und Reisepass – Urlaubsvorbereitung',
    'Mindmap auf dem Tisch eines Cafés in Italien, mit Espresso und Italienkarte',
  ],
  swipe: '👉 Wisch zur Seite für mehr',
};

export const wo = {
  kicker: 'Im Alltag und im Urlaub',
  title: 'Wo du ==Italienisch Visuell== benutzt',
  sub: 'Vom Frühstück zu Hause bis zur Piazza: Die Sätze sind für echte Situationen gemacht.',
  alt: 'Eine Mindmap am Handy, in der Hand, auf einer Piazza in Italien',
  punkte: ['☕ Beim Frühstück, 10 Minuten am Tag', '✈️ Im Flugzeug oder im Zug nach Italien', '🍝 Im Restaurant, wenn du bestellst', '🏨 Beim Einchecken im Hotel'],
};

export const kapitelTitel = {
  kicker: 'Der komplette Inhalt',
  title: 'Was du lernst: ==20 Kapitel, 300 Mindmaps==',
  sub: 'Vom Grundwortschatz bis zum Gespräch im Urlaub, Niveau A1–A2, in einer klaren Reihenfolge.',
};

export const kapitel: { t: string; d: string }[] = [
  { t: 'Erste Schritte', d: 'Grüßen, danken, bitten, Zahlen und Wochentage – und die Wörter, die du schon kennst.' },
  { t: 'Aussprache und Lesen', d: 'Wie man «gli», «gn», «sc», «ci» und «chi» spricht, Doppelkonsonanten und Betonung.' },
  { t: 'Sätze bauen', d: 'Sätze, Fragen und Verneinung, «c’è» und «ci sono» und die wichtigsten Präpositionen.' },
  { t: 'Sich vorstellen', d: '«Mi chiamo», Herkunft, Beruf, Familie und dein erstes Gespräch im Urlaub.' },
  { t: 'Sein und haben', d: '«essere» und «avere» – und warum man auf Italienisch Hunger und 30 Jahre «hat».' },
  { t: 'Artikel und Plural', d: 'il, lo, la, gli, le ohne Stress – und welche Wörter ein anderes Geschlecht haben als im Deutschen.' },
  { t: 'Präsens', d: 'Die regelmäßigen Verben auf -are, -ere und -ire für deinen Tag und deine Reise.' },
  { t: 'Unregelmäßige Verben', d: 'andare, fare, stare, venire, volere, potere, dovere, sapere und mehr.' },
  { t: 'Tagesablauf', d: 'Reflexive Verben: aufwachen, aufstehen, sich entspannen – ein Tag im Urlaub.' },
  { t: 'Fragen und Uhrzeit', d: 'Wer, was, wo, wann, wie viel – und «Um wie viel Uhr öffnet …?».' },
  { t: 'Wortschatz für den Urlaub', d: 'Bar, Restaurant, Hotel, Strand, Supermarkt, Verkehr, Wetter und Gesundheit.' },
  { t: 'Objektpronomen', d: '«Lo prendo!», «Mi piace» und wie du Wiederholungen vermeidest.' },
  { t: 'Kombinierte Pronomen', d: '«Me lo dà?», «Glielo porto» – so reden Italiener wirklich.' },
  { t: '«ci» und «ne»', d: '«Ne voglio due», «Ci vado domani», «Non ce la faccio» – endlich verstanden.' },
  { t: 'Präpositionen mit Artikel', d: 'al, del, nel, sul … und wohin du gehst: a, in oder da.' },
  { t: 'Adjektive und Vergleiche', d: 'Menschen und Orte beschreiben, mein und dein, besser und am schönsten.' },
  { t: 'Bindewörter', d: '«allora», «però», «magari» – die kleinen Wörter, die dein Italienisch natürlich machen.' },
  { t: 'Vergangenheit', d: 'passato prossimo und imperfetto – vom Urlaub erzählen.' },
  { t: 'Zukunft und Wünsche', d: '«Vorrei», «Potrebbe …?», Pläne machen und reservieren.' },
  { t: 'Im Urlaub: echte Gespräche', d: 'Restaurant, Hotel, Bahnhof, Apotheke, Mietwagen und Notfälle – ganze Dialoge.' },
];

export const warum = {
  kicker: 'Warum es funktioniert',
  title: 'Was sich beim Lernen ==für dich ändert==',
  karten: [
    { e: '🧠', t: 'Ordnung im Kopf', d: 'Du siehst, wie Wörter, Regeln und Verben zusammenhängen – statt alles einzeln zu lernen und wieder zu vergessen.' },
    { e: '🚫', t: 'Schluss mit Vokabellisten', d: 'Wörter bleiben hängen, wenn sie verbunden sind. Die Mindmaps machen das für dich.' },
    { e: '⏱️', t: 'In 5 Minuten wiederholt', d: 'Ein Blick auf die Seite reicht, um ein Thema aufzufrischen – ohne lange Texte.' },
    { e: '🇩🇪', t: 'Gemacht für Deutschsprachige', d: 'Jede Mappe zeigt den typischen Fehler von Deutschsprachigen – damit du ihn gar nicht erst machst.' },
    { e: '🗣️', t: 'Sicherheit beim Sprechen', d: 'Jede Mappe endet mit einem Mini-Dialog an einem echten Ort in Italien.' },
    { e: '📚', t: 'Vom ersten Wort bis zum Gespräch', d: 'Von der Aussprache über die Verben bis zu ganzen Gesprächen – Niveau A1 bis A2.' },
  ],
};

export const bekommst = {
  kicker: 'Sofort per E-Mail',
  title: 'Das bekommst du ==heute==',
  sub: 'Ein komplettes, visuelles Material, mit dem du Italienisch lernst – vom Alphabet bis zum Gespräch im Urlaub.',
  inklusive: 'inklusive',
  punkte: [
    { t: '300 illustrierte Mindmaps', d: 'Jedes Thema auf einer Seite, leicht zu wiederholen.' },
    { t: '20 Kapitel in fester Reihenfolge', d: 'Du weißt immer, was als Nächstes kommt.' },
    { t: 'Grammatik ohne Fachchinesisch', d: 'Artikel, Pronomen, Präpositionen und Bindewörter, einfach erklärt.' },
    { t: 'Verben in Präsens, Vergangenheit und Zukunft', d: 'Die wichtigen Formen auf einen Blick.' },
    { t: 'Wortschatz für den Urlaub', d: 'Bar, Restaurant, Hotel, Strand, Einkaufen, Apotheke.' },
    { t: '300 Mini-Dialoge aus Italien', d: 'Von Venedig bis Sizilien – Sätze, die du wirklich brauchst.' },
    { t: 'Typische Fehler von Deutschsprachigen', d: 'Damit dir «Sono caldo» nie passiert.' },
    { t: '20 Wiederholungen mit kleinem Test', d: 'Am Ende jedes Kapitels, mit Lösungen.' },
    { t: 'Zum Lesen am Handy oder zum Ausdrucken', d: 'PDF im Format A4 quer.' },
  ],
};

export const boni = {
  kicker: 'Nur in diesem Angebot',
  title: '==5 Boni== inklusive',
  sub: 'Zusätzlich zum Buch bekommst du 5 Hefte, die dein Lernen beschleunigen.',
  gratis: 'GRATIS',
  liste: [
    { t: '100 italienische Redewendungen – illustriert', d: 'Die Ausdrücke, die Italiener wirklich jeden Tag sagen – mit Bedeutung und Beispiel.' },
    { t: 'Aussprache-Guide Italienisch – visuell', d: 'Speisekarte, Städte und Marken richtig aussprechen, Betonung und Satzmelodie.' },
    { t: '200 fertige Sätze für den Urlaub', d: 'Nach Situationen sortiert: Café, Restaurant, Hotel, Bahn, Strand, Apotheke …' },
    { t: '50 Übungen mit Lösungen', d: 'Zum Ausfüllen am Handy oder auf Papier, passend zu den Kapiteln.' },
    { t: 'Falsche Freunde: 60 Wörter, die Deutsche in Italien reinlegen', d: '«caldo» ist nicht kalt und «la camera» ist keine Kamera.' },
  ],
  fazit: '5 Hefte, die gratis dabei sind.',
  cta: 'Mit den 5 Boni sichern',
};

export const fuerDich = {
  kicker: 'Ist das etwas für dich?',
  title: 'Ideal für dich, ==wenn du …==',
  liste: [
    { e: '✈️', t: 'bald nach Italien fährst', d: 'und im Restaurant, im Hotel und auf dem Markt mehr sagen willst als «Grazie».' },
    { e: '🧩', t: 'bei null anfängst', d: 'und einen klaren Weg brauchst, Schritt für Schritt, ohne dich zu verlieren.' },
    { e: '☕', t: 'im Ruhestand Zeit für dich hast', d: 'und jeden Tag 10 Minuten etwas Schönes lernen willst – ohne Kurs und ohne Prüfungsdruck.' },
    { e: '🔁', t: 'Schulitalienisch auffrischen willst', d: 'und die Grundlagen endlich geordnet vor dir sehen möchtest.' },
    { e: '🚫', t: 'Vokabellisten hasst', d: 'und lieber mit Bildern und Zusammenhängen lernst.' },
    { e: '🗣️', t: 'dich mehr trauen willst', d: 'mit fertigen Sätzen und Dialogen für echte Situationen.' },
  ],
};

export const offer = {
  kicker: 'Dein Komplett-Set',
  title: 'Komplett-Set: ==300 Mindmaps + 5 Boni==',
  sub: 'Du bekommst das Buch mit 300 Mindmaps und die 5 Bonus-Hefte. Einmal zahlen, für immer behalten.',
  card: 'KOMPLETT-SET',
  cardSub: 'Buch + 5 Boni',
  main: [
    '300 illustrierte Mindmaps (A1–A2)',
    '20 Kapitel vom ersten Wort bis zum Gespräch',
    '300 Mini-Dialoge für den Urlaub',
  ],
  cta: 'Jetzt für 19,90 € sichern',
  ctaSub: 'Weiter zur sicheren Kasse',
};

export const garantie = {
  kicker: 'Ohne Risiko',
  title: '10 Tage Geld-zurück-Garantie',
  text: [
    'Du hast 10 Tage Zeit, dir alles in Ruhe anzusehen: die Kapitel, die Mindmaps und die Boni.',
    'Wenn das Material nicht zu dir passt, schreib uns innerhalb von 10 Tagen an die E-Mail-Adresse aus deiner Bestellbestätigung – du bekommst dein Geld zurück. Ohne Wenn und Aber.',
  ],
};

export const faq = {
  title: 'Häufige Fragen',
  liste: [
    { q: 'Muss ich schon Italienisch können?', a: 'Nein. Das Buch beginnt beim ersten «Ciao» und geht Schritt für Schritt bis zum Niveau A2.' },
    { q: 'Ist das etwas für meinen Urlaub?', a: 'Genau dafür ist es gemacht: Jede Mappe hat einen Mini-Dialog an einem echten Ort in Italien – Café, Restaurant, Hotel, Bahnhof, Strand, Apotheke.' },
    { q: 'Wie bekomme ich das Material?', a: 'Direkt nach dem Kauf per E-Mail, als PDF. Du kannst sofort anfangen.' },
    { q: 'Kann ich es am Handy lesen?', a: 'Ja. Dreh das Handy einfach quer. Am Tablet oder Computer geht es genauso, und du kannst jede Seite ausdrucken (A4 quer).' },
    { q: 'Was ist genau drin?', a: '300 Mindmaps in 20 Kapiteln und 5 Bonus-Hefte: 100 Redewendungen, Aussprache-Guide, 200 Sätze für den Urlaub, 50 Übungen mit Lösungen und 60 falsche Freunde.' },
    { q: 'Sind die 5 Boni wirklich inklusive?', a: 'Ja, alle 5 Hefte kommen zusammen mit dem Buch in derselben E-Mail.' },
    { q: 'Ersetzt das einen Kurs oder Lehrer?', a: 'Es ist ein Lernmaterial zum Selbstlernen. Viele nutzen es allein, andere zusätzlich zu einem Kurs oder einer App.' },
    { q: 'Ist das ein Abo?', a: 'Nein. Du zahlst einmal und behältst das Material für immer.' },
    { q: 'Gibt es eine Garantie?', a: 'Ja, 10 Tage. Wenn es nicht zu dir passt, bekommst du dein Geld zurück.' },
    { q: 'Werde ich damit fließend?', a: 'Kein ehrliches Material kann das versprechen. Mit den 300 Mindmaps lernst du die Grundlagen bis A2 – genug, um dich im Urlaub zu verständigen.' },
  ],
};

export const schluss = {
  title: 'Dein nächster Urlaub kann ==auf Italienisch== beginnen.',
  cta: 'Ja, ich will Italienisch lernen',
  note: 'PDF sofort per E-Mail · 10 Tage Garantie',
};

export const footer = {
  line: '© 2026 Italienisch Visuell · Digitales Produkt (PDF) · Kein Abo',
  disclaimer:
    'Dieses Material garantiert nicht, dass du fließend sprichst oder eine Prüfung bestehst. Der Lernerfolg hängt von deiner Übung ab. Diese Seite ist nicht mit Facebook, Instagram oder Google verbunden.',
};
